import { render, staticRenderFns } from "./PaymentAttributeDetailCreate.vue?vue&type=template&id=68d6ab96"
import script from "../../controllers/payment_att_detail/payment-attribute-detail-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_att_detail/payment-attribute-detail-create.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeDetailCreate.vue?vue&type=style&index=0&id=68d6ab96&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports